import {HTTP} from '@/CallAPI'
export default {
  getListFAQ (page = '', per_page = '', search = '', sort = 'desc', status = '', grp_faq_id = '') {
    return HTTP.get('faqs', {
      params: {
        page,
        per_page,
        search,
        sort,
        status,
        grp_faq_id
      }
    })
  },
  showFAQ (faq) {
    return HTTP.get('faqs/' + faq.id)
  },
  createFAQ (faq) {
    return HTTP.post('faqs', faq)
  },
  updateFAQ (faq) {
    return HTTP.post('faqs/' + faq.get('id'), faq)
  },
  destroyFAQ (faq) {
    return HTTP.delete('faqs/' + faq.id)
  },
  openFAQ (faq) {
    return HTTP.post('faqs/' + faq.id + '/open')
  },
  closeFAQ (faq) {
    return HTTP.post('faqs/' + faq.id + '/close')
  },
  getListCommentOfFAQ (faq) {
    return HTTP.get('faqs/' + faq.id + '/comments')
  },
  createCommentOfFAQ (faq, comment) {
    return HTTP.post('faqs/' + faq.id + '/comments', comment)
  },
  destroyCommentOfFAQ (faq, comment) {
    return HTTP.delete('faqs/' + faq.id + '/comments/' + comment.id)
  },
  showCommentOfFAQ (faq, comment) {
    return HTTP.get('faqs/' + faq.id + '/comments/' + comment.id)
  },
  updateCommentOfFAQ (faq, comment) {
    return HTTP.post('faqs/' + faq.id + '/comments/' + comment.get('id'), comment)
  }
}



// WEBPACK FOOTER //
// ./src/service/faq.js